"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VitalSignInterpretation = void 0;
var VitalSignInterpretation;
(function (VitalSignInterpretation) {
    VitalSignInterpretation["High"] = "high";
    VitalSignInterpretation["Normal"] = "normal";
    VitalSignInterpretation["Low"] = "low";
    VitalSignInterpretation["Empty"] = "";
    VitalSignInterpretation["Obese"] = "obese";
    VitalSignInterpretation["Overweight"] = "overweight";
    VitalSignInterpretation["Underweight"] = "underweight";
})(VitalSignInterpretation || (exports.VitalSignInterpretation = VitalSignInterpretation = {}));
//# sourceMappingURL=vital-sign-interpretation.enum.js.map